import React from 'react';
import './FloorModule.less';
import { FloorTitle } from './floorTitle';
import { LeftBigRightSmall } from './leftBigRightSmall';
import { LeftOneRightTwo } from './leftOneRightTwo';
import { LeftSmallRightBig } from './leftSmallRightBig';
import { LeftTwoRightOne } from './leftTwoRightOne';
import { SingleLarge } from './singleLarge';
import { ThreeEqualDivision } from './threeEqualDivision';
import { TwoEqualDivision } from './twoEqualDivision';
import { ExtraLarge } from './extraLarge';
import autobind from 'autobind-decorator';

interface FloorModuleState {

}

interface FloorModulePropType {
    prefixCls?: string;
    floorItem?: object;
    bgData?: any;
    onFloorClick?: Function;
}

class FloorModule extends React.Component<FloorModulePropType, FloorModuleState> {
    static defaultProps = {
        prefixCls: 'floorModule',
    };

    // 是否显示楼层楼层标题
    @autobind
    setShowTitle(floorItem) {
        if (floorItem.imgUrl) {
            return floorItem && <FloorTitle floorName={floorItem.floorName} imgUrl={floorItem.imgUrl}/>;
        } else if (!floorItem.imgUrl && !floorItem.isShowName) {
            return floorItem &&
                <FloorTitle floorName={floorItem.floorName} imgUrl={floorItem.imgUrl} showline={'have'}/>;
        } else if (!floorItem.imgUrl && floorItem.isShowName) {
            return;
        }
    }

    @autobind
    _showFloorModule(id, item, index, onFloorClick) {
        let node: any = '';
        switch (item.templateId) {
            case 1:
                node = <SingleLarge
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 2:
                node = <LeftBigRightSmall
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 3:
                node = <ThreeEqualDivision
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 4:
                node = <TwoEqualDivision
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 5:
                node = <LeftOneRightTwo
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 6:
                node = <LeftSmallRightBig
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 7:
                node = <LeftTwoRightOne
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            case 8:
                node = <ExtraLarge
                    key={index}
                    floorId={id}
                    floorTemplate={item.template}
                    onFloorClick={onFloorClick}
                />;
                break;
            default:
                node = null;
        }
        return node;
    }

    render() {
        const {prefixCls, floorItem = {}, onFloorClick, bgData = {}} = this.props;
        let bgStyle: any = {};
        if (bgData) {
            bgStyle = {
                floorColour: bgData.floorColour,
            };
        }
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}-container`} style={bgData ? {background: bgStyle.floorColour} : {}}>
                    {this.setShowTitle(floorItem)}
                    {
                        floorItem && floorItem['tempList'].length > 0 && <div className={`${prefixCls}-wraper`}>
                            {
                                floorItem && floorItem['tempList'].map((item, index) => {
                                    return this._showFloorModule(floorItem['id'], item, index, onFloorClick);
                                })
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default FloorModule;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/FloorModule.tsx